import { render, staticRenderFns } from "./ContactDataDuplicate.vue?vue&type=template&id=b750bf6a"
import script from "./ContactDataDuplicate.vue?vue&type=script&lang=js"
export * from "./ContactDataDuplicate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports